import React from 'react'
import { STYLE_PAGE } from '../styles/pdf.style';
import PdfHeader from '../component/pdf.c.header';
import { cn } from '../../../utils/useFunctions';
import PdfLine from '../component/pdf.c.line';
import { PdfHeaderText } from '../component/pdf.c.headerText';
import InsuranceNumber from './insuranceNumber';
import PdfFooter from '../component/pdf.c.footer';

const AllInsuranceNumber = ({ page, balanceData }) => {

    const InsuranceLife = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_life"
      )?.expenses_insuarant_lifes;
      const InsuranceAccident = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_accident"
      )?.expenses_insuarant_accidents;
      const Insurancecar = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_car"
      )?.expenses_insuarant_cars;
      const InsuranceHome = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_home"
      )?.expenses_insuarant_homes;
      const InsuranceFire = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_fire"
      )?.expenses_insuarant_fires;


    return (
        <div className={cn(STYLE_PAGE)}>
          <PdfHeader />
          <PdfLine />
          <PdfHeaderText
            title="ประกันของคุณ"
            icon="/images/insuranceClibboard.png"
            classNameIcon="w-[35px] h-[24px]"
            classNameTitle="text-[20px] font-bold"
          />
          {/* แผนประกันของคุณ */}
          <InsuranceNumber
            InsuranceLife={InsuranceLife}
            InsuranceAccident={InsuranceAccident}
            Insurancecar={Insurancecar}
            InsuranceHome={InsuranceHome}
            InsuranceFire={InsuranceFire}
          />
    
          <PdfFooter page={page} />
        </div>
      );
}

export default AllInsuranceNumber